import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { emailVerify, NextStep } from '../api';
import { useAppContainerContext } from './AppContainer';
import { LoadingView } from './LoadingView';

export const MagicLinkController = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const { setSuccessMsg, setError, updateLoginValue } = useAppContainerContext();

    useEffect(() => {
        setSuccessMsg('Verifying your email...');
        if (!token) {
            navigate('/');
        }
        const verify = async () => {
            try {
                const data = await emailVerify(token!);
                setError(null);
                setSuccessMsg(data.message);
                updateLoginValue({ verifyToken: data?.verification_token || token! });
                if (data.next_step === NextStep.Phone) {
                    setTimeout(() => {
                        navigate(`../verify?token=${data.verification_token || token}`);
                    }, 0);
                } else if (data.next_step === NextStep.ResetPassword) {
                    setTimeout(() => {
                        navigate('../reset-password');
                    }, 0);
                } else if (data.next_step === NextStep.CreatePassword) {
                    setTimeout(() => {
                        navigate('../create-password');
                    }, 0);
                } else {
                    setTimeout(() => {
                        navigate('/');
                    }, 2800);
                }
            } catch (error: any) {
                setTimeout(() => {
                    setSuccessMsg(null);
                    setError('Invalid or expired verification link.');
                }, 600);
                setTimeout(() => {
                    navigate('/');
                }, 1800);
            } finally {
                setTimeout(() => {
                    setSuccessMsg(null);
                    setError(null);
                }, 6000);
            }
        };
        verify();
    }, []);

    return <LoadingView />;
};
